import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/admin/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

// Pages
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import NewsPage from "@/pages/NewsPage";
import NewsDetailPage from "@/pages/NewsDetailPage";
import CareersPage from "@/pages/CareersPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsConditionsPage from "@/pages/TermsConditionsPage";
import LegalDisclaimerPage from "@/pages/LegalDisclaimerPage";
import CookiePolicyPage from "@/pages/CookiePolicyPage";
import JobDetailPage from "@/pages/JobDetailPage";
import JobApplicationPage from "@/pages/JobApplicationPage";
import LocationsPage from "@/pages/LocationsPage";

// Admin Pages
import AdminLoginPage from "@/pages/admin/AdminLoginPage";
import AdminDashboardPage from "@/pages/admin/AdminDashboardPage";
import AdminApplicantsPage from "@/pages/admin/AdminApplicantsPage";
import AdminApplicantDetailPage from "@/pages/admin/AdminApplicantDetailPage";
import AdminJobsPage from "@/pages/admin/AdminJobsPage";
import AdminSettingsPage from "@/pages/admin/AdminSettingsPage";
import AdminLogoutPage from "@/pages/admin/AdminLogoutPage";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
            <Route path="/news" element={<NewsPage />} />
            <Route path="/locations" element={<LocationsPage />} />
            <Route path="/news/:articleId" element={<NewsDetailPage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
            <Route path="/terms-and-conditions" element={<TermsConditionsPage />} />
            <Route path="/legal-disclaimer" element={<LegalDisclaimerPage />} />
            <Route path="/cookie-policy" element={<CookiePolicyPage />} />
            
            {/* Job Application Routes */}
            <Route path="/careers/:jobId" element={<JobDetailPage />} />
            <Route path="/careers/:jobId/apply" element={<JobApplicationPage />} />
            
            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLoginPage />} />
            <Route path="/admin" element={<Navigate to="/admin/dashboard" replace />} />
            <Route path="/admin/dashboard" element={<ProtectedRoute><AdminDashboardPage /></ProtectedRoute>} />
            <Route path="/admin/applications" element={<ProtectedRoute><AdminApplicantsPage /></ProtectedRoute>} />
            <Route path="/admin/applications/:id" element={<ProtectedRoute><AdminApplicantDetailPage /></ProtectedRoute>} />
            <Route path="/admin/jobs" element={<ProtectedRoute><AdminJobsPage /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettingsPage /></ProtectedRoute>} />
            <Route path="/admin/logout" element={<ProtectedRoute><AdminLogoutPage /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
